import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import Session from '../Outside/Session.js';
import IncidentForm from '../Outside/IncidentForm';

const SessionManage = observer(class SessionManage extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.completeIncident = this.completeIncident.bind(this);
  }

  completeIncident() {
    const { translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;

    ManagerStore.reportIncident = false;
    ManagerStore.incidentSession = null;
    SessionStore.showToaster(translation.incident_saved, 'success');
  }

  render() {
    const { translation } = this.props;
    const { ManagerStore, SessionStore } = this.props.store;

    return (
      <div>
        <ul className="block-list session-list">
          <Session {...this.props} />
        </ul>

        <div className={`session-interact ${ManagerStore.reportIncident ? 'active' : ''}`}>
          <div className="panel--brief">
            <h2>{translation.report_incident}</h2>

            {ManagerStore.reportIncident &&
              <IncidentForm
                installSid={SessionStore.userData.installSid}
                examSid={ManagerStore.session.examSid}
                completeIncident={this.completeIncident}
                {...this.props}
              />
            }

            <button className="btn--link" onClick={this.cancelAdd}>{translation.cancel}</button>
          </div>
        </div>
      </div>
    )
  }
})

export default translate('SessionManager')(SessionManage);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/SessionManage.js